import React, { useEffect } from 'react';
import {styled} from "@mui/system";
import Messages from "./Messages/Messages";
import NewMessageInput from "./NewMessageInput";
import { getDirectChatHistory } from '../../realtimeCommunication/socketConnection';
import VoiceChannelView from "./VoiceChannelView";

const Wrapper=styled("div")({
    flexGrow:"1",
    height:"100%",

})

const MessengerContent = ({chosenChatDetails}) => {
    useEffect(()=>{
      if (!chosenChatDetails?.channelType) {
        getDirectChatHistory({receiverUserId:chosenChatDetails.id})
      }

    },[chosenChatDetails])
  if (chosenChatDetails?.channelType === "VOICE") {
    return <VoiceChannelView />;
  }

  return (
    <Wrapper>
      <Messages/>
      <NewMessageInput/>
    </Wrapper>
  )
}

export default MessengerContent
